import * as React from 'react';
import * as styles from './styles.css';

import { RadioButtonGroup } from '@cian/ui-kit';

import { ITabsProps } from '../types';
import { EDealType } from '../../../types/dealType';

type TMobileViewProps = ITabsProps & {
  ref?: React.Ref<HTMLDivElement>;
};

export function MobileView({ tabs, dealType, onChange, ref }: TMobileViewProps): React.JSX.Element {
  return (
    <div ref={ref} data-testid="TabsMobileViewId" className={styles['container']}>
      <RadioButtonGroup
        options={tabs}
        value={dealType}
        onChange={(_, value) => onChange(value as EDealType)}
        disabled={tabs.some(tab => tab.disabled)}
      />
    </div>
  );
}
